import { path } from 'ramda';
import { useMemo } from 'react';
import { AboutBuilding } from '../../components/AboutBuilding';
import { useOfferContext } from '../OfferContext';

export const AboutBuildingContainer = () => {
  const { building, geo } = useOfferContext();

  const buildingInfo = useMemo(() => {
    if (!building) {
      return undefined;
    }

    const { houseName, deadline } = building;

    const buildingInfo = [houseName, deadline].filter(Boolean).join(', ');

    return buildingInfo || undefined;
  }, [building]);

  const { link, name } = useMemo(
    () => ({
      name: path<string>(['title', 'name'], geo),
      link: path<string>(['title', 'link'], geo),
    }),
    [geo],
  );

  return <AboutBuilding name={name} buildingInfo={buildingInfo} link={link} />;
};
